/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PixRecurrenceDetail {
  contrato?: string;
  dateCreated?: Date;
  dateStart?: Date;
  firstTID?: string;
  firstTxid?: string;
  frequency?: PixRecurrenceDetail.FrequencyEnum;
  gatewayId?: number;
  idRec?: string;
  payments?: number;
  personId?: number;
  pixRecurrenceId?: number;
  retryPolicy?: PixRecurrenceDetail.RetryPolicyEnum;
  status?: PixRecurrenceDetail.StatusEnum;
  subscriberId?: number;
  subscriptionTypeId?: number;
  subscriptionTypeName?: string;
}
export namespace PixRecurrenceDetail {
  export type StatusEnum =
    | 'CRIADA'
    | 'ATIVA'
    | 'REJEITADA'
    | 'CANCELADA_BANCO'
    | 'CANCELADA_GLAM';
  export const StatusEnum = {
    CRIADA: 'CRIADA' as StatusEnum,
    ATIVA: 'ATIVA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    CANCELADABANCO: 'CANCELADA_BANCO' as StatusEnum,
    CANCELADAGLAM: 'CANCELADA_GLAM' as StatusEnum
  };
  export type FrequencyEnum =
    | 'SEMANAL'
    | 'MENSAL'
    | 'TRIMESTRAL'
    | 'SEMESTRAL'
    | 'ANUAL';
  export const FrequencyEnum = {
    SEMANAL: 'SEMANAL' as FrequencyEnum,
    MENSAL: 'MENSAL' as FrequencyEnum,
    TRIMESTRAL: 'TRIMESTRAL' as FrequencyEnum,
    SEMESTRAL: 'SEMESTRAL' as FrequencyEnum,
    ANUAL: 'ANUAL' as FrequencyEnum
  };
  export type RetryPolicyEnum = 'NAO_PERMITE' | 'PERMITE_3R_7D';
  export const RetryPolicyEnum = {
    NAOPERMITE: 'NAO_PERMITE' as RetryPolicyEnum,
    PERMITE3R7D: 'PERMITE_3R_7D' as RetryPolicyEnum
  };
}
